export const NAVIGATION_LIST_INITIAL_LEVEL = 0;
